import { createApp } from "vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import ElementPlus from "element-plus";
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import "element-plus/dist/index.css";
import mitt from "mitt";
import App from "./App.vue";
import i18n from "@/language";

axios.interceptors.request.use(function(config){
  config.headers.Authorization = sessionStorage.getItem("token")
  return config
});

const app = createApp(App);
app.config.globalProperties.eventBus = mitt();
app.config.globalProperties.axios = axios;
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(i18n)
app.use(router);
app.use(store);
app.use(ElementPlus);
app.mount("#app");
